import { render } from "./RegisterExterno.vue?vue&type=template&id=c4ae00d2"
import script from "./RegisterExterno.vue?vue&type=script&lang=js"
export * from "./RegisterExterno.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/Smart2Docs_Front-end/Smart2Docs_Front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__